module.exports = __webpack_public_path__ + "static/media/lucy1901.d723b77d.png";